// objeto con las traducciones, para este proyecto se usa como almacén de textos, pués sólo existe un idioma
export const messages = {
    // código país    
    es: {
        login: {
            appAccess: "Introduce tus credenciales para acceder",
            userPlaceholder: "Usuario",
            companyPlaceholder: "Empresa",
            passwordPlaceholder: "Contraseña",
            emailPlaceholder: "Email",
            repeatPasswordPlaceholder: " Repetir contraseña",
            rememberMe: "Recuérdame",
            btnSignIn: "Acceder",            
            passwordForgotten: "¿Olvidaste tu contraseña?",
            welcome: "Bienvenido / a",
            doClickToAccess: "Haz click en el menú para acceder",
            btnLogOut: "Cerrar sesión",
            error: "Ha ocurrido el siguiente error",
            success: "Proceso realizado correctamente",
            msgInvalidEmail: "El email no es válido",
            msgEmptyFields: "Todos los campos son obligatorios",
            msgModalResetPasswordForgot: "¿Has olvidado tu contraseña?",
            msgModalResetPasswordSetUserAndCompany: "Por favor, introduce tu nombre de usuario y empresa y te enviaremos a tu email asociado un link para restablecerla.",
            msgResetPasswordPage: "Bienvenido, por favor, introduzca una nueva contraseña",
            msgPasswordsNotEqual: "Las contraseñas no coinciden",
            btnSendEmail: "Enviar",  
            btnCloseModal: "Cerrar"
        },
        navBar: {
            inputSearchPlaceholder: "Búsqueda rápida",
            notifications: "CRITERIOS DE LA BÚSQUEDA RÁPIDA",
            noNotifications: "No existen criterios",
            editProfile: "Editar Perfil",
            inbox: "Notificaciones",
            calendar: "Calendario",
            settings: "Ajustes",
            logOut: "Cerrar Sesión",
            submit: "Consultar"
        },
        themePanel: {
            colorSettings: "Ajustes de Color",
            darkMode: "Modo Oscuro",
            headerFixed: "Cabecera Fija",
            headerInverse: "Cabecera Inversa",
            sidebarFixed: "Barra Lateral Fija",
            sidebarGrid: "Rejilla Barra Lateral",
            sidebarGradient: "Selector Barra Lateral",
            sidebarTransparent: "Barra Lateral Transp.",
            sidebarRight: "Barra Lateral Derecha",
            sidebarLight: "Barra Lateral Clara",
            topMenu: "Menú Superior",
            documentation: "Documentación",
            resetSettings: "Restaurar Configuración"
        },
        sideBar: {
            brandSubtitle: "Demo de Panel de Control",
            aboutUs: "Sobre Nosotros",
            contact: "Contacto",
            privatePolicy: "Política de Privacidad"
        },
        screensTitles: {
            grid: "Tabla de pedidos",
            forms: "Gestión de clientes"
        },
        grid: {
            datepickerPlaceholder: "Selecciona una fecha o período",
            btnReload: "Recargar Datos",
            grouping: "Agrupar datos",
            groupingTooltipText: "Abir / cerrar funcionalidad para agrupar datos por columnas",
            saveOptions: "Guardar configuración",
            saveOptionsTooltipText: "Guardar la configuración de la tabla con los valores seleccionados",
            restoreOptions: "Restaurar configuración",
            restoreOptionsTooltipText: "Restaurar la configuración de la tabla a sus valores por defecto",
            dateFormatMessage: "El formato debe ser 'dd/MM/yyyy'",
            footerExportPDFPage: "Página",
            footerExportPDFOf: "de",
            columns: {
                orderNumber: "N.Pedido",
                date: "Fecha",
                customer: "Cliente",                
                product: "Producto",
                price: "Precio",
                quantity: "Cantidad",
                amount: "Importe",
                destiny: "Destino",
                status: "Estado",
                progress: "Progreso",
                paid: "Pagado",
                descriptionOrderNumber: "Número de pedido",
                descriptionDate: "Fecha del pedido",
                descriptionCustomer: "Nombre del cliente",
                descriptionRating: "Rating del cliente",                
                descriptionProduct: "Nombre del producto",
                descriptionPrice: "Precio unitario del producto",
                descriptionQuantity: "Cantidad pedida",
                descriptionAmount: "Importe total del pedido",
                descriptionDestiny: "Destino de la mercancía",
                descriptionStatus: "Estado del pedido",
                descriptionProgress: "Progreso del pedido",
                descriptionPaid: "Pedido pagado si / no"
            },           
        },
    }
}
/* appOption.appHeaderMegaMenu = true;
    appOption.appSidebarTwo = true;
    appOption.appHeaderInverse = false;
    appOption.appHeaderSearchToggled = true;
    // sidebar izquierda abierta / colapsada
    appOption.appSidebarMinified = false;
    // opciones del contenido de la vista:
    appOption.appContentFullHeight = false;
    appOption.appContentClass = "p-3 bg-component";

    beforeRouteLeave(to, from, next) {
        appOption.appHeaderMegaMenu = false;
        appOption.appSidebarTwo = false;
        appOption.appHeaderSearchToggled = false;
        appOption.appHeaderInverse = false;
        appOption.appSidebarMinified = false;
        appOption.appContentFullHeight = false;
        appOption.appContentClass = "";
        next();
      },

      var targetHeight =
      window.innerHeight -
      document.getElementById("table").getBoundingClientRect().top;
    document.getElementById("table").style.height = targetHeight + "px"; */